import React from "react";

export interface FormatConfig {
  decimal: string;
  scale: string;
}

interface FormatButtonsProps {
  formatConfig: FormatConfig;
  onFormatChange: (formatConfig: FormatConfig) => void;
}

const formatButtonGroups = [
  {
    type: "decimal",
    buttons: [
      { label: ".0", value: "decimal_0" },
      { label: ".00", value: "decimal_00" },
    ],
  },
  {
    type: "scale",
    buttons: [
      { label: "K", value: "thousands" },
      { label: "M", value: "millions" },
      { label: "B", value: "billions" },
    ],
  },
] as const;

// Same decimal / scale toggles as the Financials page (ReportFilters).
// Clicking the active button clears it.
export const FormatButtons: React.FC<FormatButtonsProps> = ({
  formatConfig,
  onFormatChange,
}) => {
  const handleClick = (format: string, groupType: "decimal" | "scale") => {
    const current = formatConfig[groupType];
    onFormatChange({
      ...formatConfig,
      [groupType]: current === format ? "" : format,
    });
  };

  return (
    <div className="flex items-center gap-3">
      {formatButtonGroups.map((group) => (
        <div key={group.type} className="flex items-center">
          {group.buttons.map((button, buttonIndex) => {
            const isActive = formatConfig[group.type] === button.value;
            return (
              <button
                key={button.value}
                type="button"
                onClick={() => handleClick(button.value, group.type)}
                className={`
                  px-3 py-1.5 text-sm font-medium border transition-colors duration-200
                  ${buttonIndex === 0 ? "rounded-l-md" : ""}
                  ${
                    buttonIndex === group.buttons.length - 1
                      ? "rounded-r-md"
                      : ""
                  }
                  ${buttonIndex > 0 ? "border-l-0" : ""}
                  ${
                    isActive
                      ? "bg-gray-300/60 text-gray-700 border-gray-300/60 z-10 relative"
                      : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                  }
                `}
              >
                {button.label}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};
